import highway9Logo from "./highway9-logo.svg";
import radioIndoor from "./Radio-Indoor-Icon.svg";
import monitorLogo from "./data_exploration.svg";

export const asset = {
  highway9Logo,
  radioIndoor,
  monitorLogo,
};
